var Module = (function(){

  var _selectedColors = [],
      _selectedYarns = [];

  var initPopUp = function(colors){
  	var pop_up =
        '<div class="popup-compare" style="display:none;">' +
          '<div class="popup-compare-mask"></div>' +
          '<div class="popup-compare-body">' +
  		    '<div class="popup-compare-header">' +
        	  '<% for(var i in this.colors) { %>' +
        	    '<a class="tooltip" href="#" title="<% this.colors[i].label %>" data-image="<% this.colors[i].image %>" data-label="<% this.colors[i].label %>">' +
    			  '<img src="<% this.colors[i].image %>" />' +
        		'</a>' +
        	  '<% } %>' +
            '</div>' +
        	'<div class="popup-compare-main">' +
    		  '<h4>Choose a thumbnail to compare</h4>' +
              '<div class="compare-canvas"><ul></ul></div>' +
        	  '<a href="#" class="popup-compare-close"><i class="icon-close"></i></a>' +
    		'</div>' +
    	  '</div>' +
        '</div>';
	var render = templateEngine(pop_up, {
	  colors: colors
	});
    $('body').append(render);
    $('.popup-compare').fadeIn();
    popupVerticalAlign();
  };

  var loadYarns = function(entries){
    var entriesAvailable = false;
    entries.forEach(function(entry){
      if (entry.available) {
        entriesAvailable = true;
      }
    })

  	var markup =
        '<div class="grid-products">' +
          '<% for(var i in this.entries) { %>' +
        	'<% if(this.entries[i].available) { %>' +
              '<div id="yarn" class="yarn product" data-id="<% this.entries[i].id %>">' +
                '<img style="object-fit: cover;" src="<% this.entries[i].image %>" width="100%" />' +
                '<h3 class="card__heading h5">' +
                  '<a class="full-unstyled-link" href="#"><% this.entries[i].title %></a>' +
                '</h3>'+
                '<div class="card-information">' +
                  '<div class="price">' +
                    '<div class="price__container">' +
                      '<div class="price-item"><% this.entries[i].price %></div>' +
                    '</div>' +
                  '</div>' +
                '</div>'+
                '<quantity-input class="quantity">' +
                        ' <button class="quantity__button no-js-hidden disabled" name="minus" type="button">'+
                '                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg>' +
                '                  </button>' +
                '                  <input class="quantity__input" type="number" name="quantity" data-id="<% this.entries[i].id %>" id="Quantity-template--<% this.entries[i].id %>" data-cart-quantity="0" data-min="1" min="1" step="1" value="1" form="">' +
                '                  <button class="quantity__button no-js-hidden" name="plus" type="button">'+
                '                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>'+
                '                  </button>' +
                '                </quantity-input>' +
              '</div>' +
        	'<% } %>' +
          '<% } %>' +
        '</div>';


    if (entriesAvailable) {
      var render = templateEngine(markup, {
        entries: entries
      });
    
      $('.yarns-container').append(render);
    } else {
      $(".button--cart").hide();
    }
    $(".button--cart").prop('disabled', true);
    $('.product__variants, .product-meta__prices').hide();
    $(".product__quantity").hide();
    $(".collection__product_stock, .product_stock").hide();
    $(".wishl-add-wrapper").hide();
  };

  var addToCanvas = function(el){
    var target = {label: el.data('label'), image: el.data('image')};
    if(_selectedColors.indexOf(target.label) == -1){
      _selectedColors.push(target.label);
      if(_selectedColors.length > 1){
      	$('.popup-compare-main h4').text('Drag and drop to sort, close to reset');
      }else{
      	$('.popup-compare-main h4').text('Choose a thumbnail to compare');
      };
      var box =
          '<li class="compare-box" data-label="<% this.label %>">' +
            '<img src="<% this.image %>" />' +
            '<span class="label"><% this.label %></span>' +
          	'<span class="remove"><i class="icon-close"></i></span>'
          '</li>';
      var render = templateEngine(box, target);
      $('.compare-canvas > ul').append(render);
      $('.compare-canvas img').load(function(){
        popupVerticalAlign();
      });
    };
    // sortable restart
    $('.compare-canvas ul').sortable();
    $('.compare-canvas ul').disableSelection();
  };

  var selectYarns = function(el){
    var id = el.data('id');
    var quantity = parseInt(el.find('.quantity > input').val());
    var exists = $.grep(_selectedYarns, function(e){ return e.id == id; }).length == 0 ? false : true;
    if(!exists){
      _selectedYarns.push({id: id, quantity: quantity});
      el.addClass('selected');
    }else{
      clearYarns(el);
    };
  };

  var updateYarns = function(args){
  	var exists = $.grep(_selectedYarns, function(e){ return e.id == args.id; }).length == 0 ? false : true;
    if(exists){
      $.each(_selectedYarns, function(i,e){
        if(e.id == args.id)
          e.quantity = args.quantity;
      });
    };
  };

  var clearYarns = function(el){
    var id = el.data('id');
  	_selectedYarns = $.grep(_selectedYarns, function(e){
      return e.id != id;
    });
    el.removeClass('selected');
  };

  var removeFromCanvas = function(el){
    var label = el.data('label');
  	_selectedColors = $.grep(_selectedColors, function(value){
      return value != label;
    });
    el.remove();
    popupVerticalAlign();
  };

  var popupVerticalAlign = function(){
  	var height = ($('.popup-compare-body').height() / 2) * -1;
    $('.popup-compare-body').css('margin-top', height);
  };

  var addSelectedYarsToCart = function(callback){
  	var queue = _selectedYarns;
    if(queue.length){
      var r = queue.shift();
      $.ajax({
        url: "/cart/add.js",
        data: {id: r.id, quantity: r.quantity},
        type: "post",
        dataType: "json",
        success: addSelectedYarsToCart
      });
      //Shopify.addItem(r.id, r.quantity, addSelectedYarsToCart);
    }else{
      location.reload();
    };
  };

  // event listeners

  var eventListeners = function(){

    // jQuery UI support
    $(document).tooltip({
      items: '.tooltip',
      tooltipClass: 'custom-tooltip',
      position: {
      	my: "center top+10",
        at: "center bottom"
      }
    });
    // regular listeners
    // start comparing yarns
    $(document).on('click', '.popup-compare-header > a', function(){
      addToCanvas($(this));
      return false;
    });
    // close popup
    $(document).on('click', '.popup-compare-close, .popup-compare-mask', function(){
      $('.popup-compare').fadeOut(function(){
        $(this).remove();
      });
      _selectedColors = [];
      return false;
    });
    // remove colors from selection
    $(document).on('click', '.compare-canvas .remove', function(){
      var dom_el = $(this).parents('li');
      removeFromCanvas(dom_el);
      return false;
    });
    $(document).on('click', '.yarn', function(event){
      const checkTarget = $(event.target).attr('class');
      console.log(checkTarget);
      if(checkTarget){
        if(checkTarget.includes('quantity__button')){
          return;
        }
      }
      selectYarns($(this));
      $('.button--cart').prop('disabled', false);
      if(_selectedYarns.length == 0){
      	$('.button--cart').prop('disabled', true);
      };
    });
    $(document).on('click', '.quantity > input', function(e){
      e.stopPropagation();
    });
    $(document).on('change', '.quantity > input', function(){
      var i = $(this).data('id');
      var q = parseInt($(this).val());
      updateYarns({id: i, quantity: q});
    });
    $(document).on('click', '.button--cart', function(e){
      if(window.product.linked_yarns.length){
        e.preventDefault();
        addSelectedYarsToCart();
      };
    });
  };

  // helpers

  var templateEngine = function(html, options) {
    var re = /<%\s([^%>]+)?\s%>/g,
        reExp = /(^( )?(if|for|else|switch|case|break|{|}))(.*)?/g,
        code = 'var r=[];\n', cursor = 0, match;
    var add = function(line, js) {
      js? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
          (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
      return add;
    };
    while(match = re.exec(html)) {
      add(html.slice(cursor, match.index))(match[1], true);
      cursor = match.index + match[0].length;
    };
    add(html.substr(cursor, html.length - cursor));
    code += 'return r.join("");';
    return new Function(code.replace(/[\r\t\n]/g, '')).apply(options);
  };

  var cartChange = function(a,b,c){
  	$.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {id: a, quantity: b},
      dataType: 'json',
      success: function(e){ c(); },
      error: function(e){ console.log(e); }
    });
  };
  //loadYarns();
  return {

    init: function(){
      eventListeners();
    },

    compare: function(options){
      // show popup with images
      initPopUp(options.colors);
    },

    yarns: function(entries){
      loadYarns(entries);
    },

    debug: function(){
      console.log('COLORS:' + _selectedColors);
      console.log('YARNS:' + JSON.stringify(_selectedYarns));
  	}

  };

}());
